import { defineStore } from "pinia";
import { db } from "@/firebase/index.js";
import { collection, onSnapshot } from "firebase/firestore";
export const homeStore = defineStore("home-store", {
  state: () => {
    return {
      dailyPosts: {
        Hadith: "",
        duea: "",
        question: {
          questionText: "",
          answers: [],
        },
        NamesOfAllah: {
          name: "",
          text: " ",
        },
        TransDuea: [
          {
            ar: "",
            en: "",
          },
        ],
      },
    };
  },
  actions: {
    getdocs() {
      const colRef = collection(db, "Daily-posts");
      onSnapshot(colRef, (snapshot) => {
        let res = [];
        snapshot.docs.forEach((doc) => {
          res.push({ ...doc.data(), id: doc.id });
        });
        this.dailyPosts = res[0];
      });
    },
  },
});
